'use client';

import { Gift } from 'lucide-react';
import { useTranslations } from 'next-intl';
import type { PropertyDetailListing } from '@/src/components/features/property/types';
import { LucideIcon } from '@/src/components/LucideIcon';
import Card from '@/src/components/features/property/ui/Card';
import { ReadMoreText } from '@/src/components/features/property/lib/ReadMoreText';
import { specialOfferBody, specialOfferCard, specialOfferHeading } from './costAndFeesModule.styles';

type Props = {
  listing: PropertyDetailListing;
  collapseDescription?: boolean;
};

export const SpecialOfferBanner = ({ listing, collapseDescription = true }: Props) => {
  const t = useTranslations('hdp');
  const specialOffers = listing.specialOffers;
  if (!specialOffers || specialOffers.length === 0) return null;
  const offer = specialOffers[0];
  const description = offer.description ?? '';

  return (
    <Card variant="accent" size="md" className={specialOfferCard}>
      <div className={specialOfferHeading}>
        <LucideIcon icon={Gift} size="sm" />
        {t('specialOffer')}
      </div>
      <div className={specialOfferBody}>
        {collapseDescription ? (
          <ReadMoreText
            controlsId="cost-and-fees-special-offer-banner"
            content={description}
            maxTruncatedLength={80}
            readMoreText={t('readMore')}
            readLessText={t('readLess')}
          />
        ) : (
          description
        )}
      </div>
    </Card>
  );
};
